import React, { useMemo } from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import { setPendingLeaveConfirmation } from "@/fm/lib/leave_confirm_store";
import { LeaveConfirmProvider } from "@/fm/components/leave_confirm_provider";
import { ToastProvider } from "../components";
import { SWRClient } from "../components/swr_client";
import { dictionaryEN } from "../locale/en";
import { dictionaryHE } from "../locale/he";
import { dictionaryES } from "../locale/es";
import { I18nProvider } from "../lib/i18n/i18n_provider";

import { SentryProvider } from "./sentry";
import { SplitIOProvider } from "./splitio";
import { enLocale } from "../offering/locale_data";
import { ConfigProvider } from "./config";
import { dictionaryPL } from "../locale/pl";
import { TalkToUsProvider } from "@/hooks/use_talk_to_us_state";

interface AppProviderProps {
  children?: React.ReactNode;
}

export function AppProvider(props: AppProviderProps) {
  const { children } = props;

  const history = useMemo(
    () =>
      createBrowserHistory({
        getUserConfirmation: (_message, callback) => {
          setPendingLeaveConfirmation(callback);
        },
      }),
    []
  );

  return (
    <Router history={history}>
      <LeaveConfirmProvider />
      <ConfigProvider>
        <SentryProvider>
          <SplitIOProvider>
            <TalkToUsProvider>
              <I18nProvider
                fallbackLocale={enLocale}
                initialDictionary={{
                  en: dictionaryEN,
                  "en-US": dictionaryEN,
                  he: dictionaryHE,
                  "he-IL": dictionaryHE,
                  pl: dictionaryPL,
                  "pl-PL": dictionaryPL,
                  es: dictionaryES,
                  "es-ES": dictionaryES,
                }}
              >
                <ToastProvider>
                  <SWRClient>{children}</SWRClient>
                </ToastProvider>
              </I18nProvider>
            </TalkToUsProvider>
          </SplitIOProvider>
        </SentryProvider>
      </ConfigProvider>
    </Router>
  );
}
